(() => {
  if (window.wileyxPrescriptionAvailability) return;
  window.wileyxPrescriptionAvailability = true;

  const selector = '[data-lensadvizor-btn]';
  const markerSelector = '[data-variant-info="prescription_availability"]';
  const originals = new WeakMap();
  let scheduled = false;

  function markerFor(button) {
    return button.closest('.section-main-product')?.querySelector(markerSelector)
      || document.querySelector(`.section-main-product ${markerSelector}`);
  }

  function blocked(button) {
    return markerFor(button)?.dataset.prescriptionUnavailable === 'true';
  }

  function update() {
    scheduled = false;
    document.querySelectorAll(selector).forEach((button) => {
      if (blocked(button)) {
        if (!originals.has(button)) {
          originals.set(button, {
            html: button.innerHTML,
            tabindex: button.getAttribute('tabindex'),
            ariaDisabled: button.getAttribute('aria-disabled'),
            ariaLabel: button.getAttribute('aria-label'),
            className: button.getAttribute('class'),
          });
        }
        const label = markerFor(button).dataset.soldOutLabel;
        if (button.textContent !== label) button.textContent = label;
        if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
        if (!button.hasAttribute('data-rx-threshold-blocked')) button.setAttribute('data-rx-threshold-blocked', '');
        button.classList.add('button', 'button-add-to-cart', 'button-primary', 'w-full', 'min-w-fit', 'disabled');
        if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
        if (button.getAttribute('tabindex') !== '-1') button.setAttribute('tabindex', '-1');
      } else if (originals.has(button)) {
        const original = originals.get(button);
        button.innerHTML = original.html;
        button.removeAttribute('data-rx-threshold-blocked');
        for (const [name, value] of [['tabindex', original.tabindex], ['aria-disabled', original.ariaDisabled], ['aria-label', original.ariaLabel], ['class', original.className]]) {
          if (value === null) button.removeAttribute(name);
          else button.setAttribute(name, value);
        }
        originals.delete(button);
      }
    });
  }

  // Capture before the app's click/keyboard handlers, including after a style swap.
  function guard(event) {
    if (event.type === 'keydown' && !['Enter', ' '].includes(event.key)) return;
    const button = event.target instanceof Element ? event.target.closest(selector) : null;
    if (!button || !blocked(button)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  window.addEventListener('click', guard, true);
  window.addEventListener('keydown', guard, true);

  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-prescription-unavailable', 'data-la-variant-id'],
  });
  update();
})();
